import { render, staticRenderFns } from "./SubCategoriesTab.vue?vue&type=template&id=1ed912a5&scoped=true&"
import script from "./SubCategoriesTab.vue?vue&type=script&lang=js&"
export * from "./SubCategoriesTab.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoriesTab.vue?vue&type=style&index=0&id=1ed912a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed912a5",
  null
  
)

export default component.exports